<template>
  <div class="pre_select_one">
    <div v-show="dataHas">
      <!-- 点击响应 不太好 -->
      <!-- <select
        class="pre_select"
        v-model="sel_val"
      >
        <option
          v-for="(item,index) in sel_data"
          :key="index"
          :value="item.val"
        >{{item.val}}</option>
      </select> -->
      <!-- 鼠标悬浮 展开 推荐 -->
      <!-- <div class="pre_dropdown">
        <input type="text" v-model="sel_val" v-on:mouseover="opendata" placeholder="请选择" />
        <div id="pre_content" class="pre_dropdown_content" v-show="show_content">
          <ul>
            <li v-for="(item, index) in sel_data" :key="index" :value="item.val" @click="choseValue(item.id)">
              {{ item.val }}
            </li>
          </ul>

        </div>
      </div> -->
      <el-select v-model="sel_val" clearable placeholder="待选" @change="choseValue">
        <el-option v-for="item in sel_data" :key="item.id" :label="item.val" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div v-show="dataNo">
      <div>暂无数据</div>
    </div>
  </div>
</template>
<script>
  /*
名称：下拉菜单组件
日期：2019-03-21
作者：hj
目标：1、传入一组数组， [{"id":"1","val":"数据1"},{"id":"2","val":"数据2"},{"id":"3","val":"数据3"}]
     2、可以设置默认选择。{"id":"1","val":"数据1"}
     3、返回选择结果
*/

  export default {
    name: "pre_select_one",
    data() {
      return {
        sel_data: [],
        dataHas: true,
        dataNo: false,
        sel_val: "",
        show_content: true,
        back_list: [],
      }
    },
    props: {
      searchList: Array,
      selectValue: {
        type: Object,
        default: {}
      },
      selectRandom:String
    },
    watch: {
      searchList(val) {
        if (val.length > 0) {
          this.loadData();
        }
      },
      selectRandom(val){
        this.sel_val='';
        // 用来清空每次首次 展示时原来选择的默认值
      }


    },
    mounted() {

      this.loadData();
    },
    activated: function() {
      console.log('keep-alive 组件激活时调用 激活');
    },
    methods: {
      loadData: function() {
        this.sel_data = [];
        // this.sel_data = this.searchList;
        // console.log(this.selectValue);
        if (this.searchList.length > 0) {
          for (let i = 0; i < this.searchList.length; i++) {
            let o = {};
            o.id = this.searchList[i].id;
            o.val = this.searchList[i].val;
            o.isSelect = true;
            this.sel_data.push(o);
          }
        }



        if (this.sel_data.length > 0) {
          this.dataHas = true;
          this.dataNo = false;
          for (var i = 0; i < this.sel_data.length; i++) {
            if (this.sel_data[i].id == this.selectValue.id) {
              this.sel_val = this.sel_data[i].val;
              this.sel_data[i].isSelect = true;
              break;
            }
          }
        } else {
          this.dataHas = false;
          this.dataNo = true;
        }
      },
      choseValue(item) {
        // console.log('选择=' + item);
        // console.log(this.sel_val);

        let tval = '';

        // 悬浮框 是{"id":"","val":""}
        for (let i = 0; i < this.sel_data.length; i++) {
          if (this.sel_data[i].id == item) {
            tval = this.sel_data[i].val;
            this.sel_val = tval;
            this.sel_data[i].isSelect = true;
          } else {
            this.sel_data[i].isSelect = false;
          }
        }
        // if (item == '0') {
        //   console.log('清理完毕........');
        //   this.sel_val = '';
        // }

        // 刷新 父页面 对应参数
        this.$emit('selectFunc', item, tval);

        // this.show_content=false;

      },
      father_change:function(id){
        // add 2021-11-12
        // 父组件 没有通过下拉选择 时 变更了数据，此时在这里更新子组件默认选择值
        // console.log('父传入 id='+id);
        // console.log(this.sel_data);

        for (let i = 0; i < this.sel_data.length; i++) {
          if (this.sel_data[i].id == id) {
            let tval = this.sel_data[i].val;
            this.sel_val = tval;
            this.sel_data[i].isSelect = true;
          } else {
            this.sel_data[i].isSelect = false;
          }
        }


      },
      opendata: function() {
        this.show_content = true;
      }
    }
  }
</script>

<style scoped>
  .pre_select_one {
    display: inline-block;
  }

  .pre_select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: transparent;
    /* border: 1px solid #87cefa; */
    border-radius: 8px;
    padding-left: 10px;
    min-width: 120px;
    width: auto;
    height: 36px;
  }


  .pre_dropdown {
    position: relative;
    display: inline-block;
    /* border: 1px solid #87cefa; */
    border-radius: 8px;
    /* min-width: 120px; */
    width: auto;
    height: 24px;
    line-height: 24px;
  }

  .pre_dropdown>input {
    display: inline-block;
    min-width: 120px;
    width: 120px;
  }

  .pre_dropdown_content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 120px;
    width: auto;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    margin-top: 0px;
    /* padding: 12px 16px; */
    z-index: 1;
    height: 120px;
    /* max-height: 120px; */
    overflow-y: scroll;
  }

  .pre_dropdown:hover .pre_dropdown_content {
    display: block;
  }

  .pre_dropdown_content>p:hover {
    background-color: #baebfc;
    border-radius: 3px;
  }

  .pre_dropdown_content>ul {
    list-style: none;
  }

  .pre_dropdown_content>ul>li {
    display: block;
    padding-left: 5px;
    padding-right: 5px;
    margin-top: 5px;
    line-height: 22px;
    word-break: keep-all;
    min-width: 120px;
    width: 120px;
    overflow-x: auto;
  }

  .pre_dropdown_content>ul>li:hover {
    background-color: #baebfc;
    border-radius: 3px;
    cursor: pointer;
  }
</style>
